import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/portal/apps/reporting/custom/")({
  beforeLoad: () => {
    // Redirect to reporting dashboard - custom reports are listed there
    throw redirect({ to: "/portal/apps/reporting" });
  },
});
